import React from "react";

export default props => {
  return (
    <svg x="0" y="0" viewBox="0 0 20 21" xmlSpace="preserve" fill={props.color}>
      <g>
        <defs>
          <path
            id="SVGID_1_"
            d="M5,17.7h10c0.9,0,1.7,0.7,1.7,1.7c0,0.9-0.7,1.7-1.7,1.7H5c-0.9,0-1.7-0.7-1.7-1.7
     C3.3,18.4,4.1,17.7,5,17.7z"
          />
        </defs>
        <use xlinkHref="#SVGID_1_" />
        <clipPath id="SVGID_2_">
          <use xlinkHref="#SVGID_1_" />
        </clipPath>
        <g
          className="st0"
          style={{ clipPath: "url(#SVGID_2_)", fill: props.color, stroke: props.color }}
        >
          <defs>
            <rect id="SVGID_3_" y="1" width="20" height="20" />
          </defs>
          <use xlinkHref="#SVGID_3_" />
          <clipPath id="SVGID_4_">
            <use xlinkHref="#SVGID_3_" />
          </clipPath>
          <rect
            x="-1.7"
            y="12.7"
            className="st1"
            width="23.3"
            height="13.3"
            style={{ opacity: 0.2, clipPath: "url(#SVGID_4_)", fill: props.color }}
          />
        </g>
      </g>
      <g>
        <defs>
          <path
            id="SVGID_5_"
            d="M2,0h16c1.1,0,2,0.9,2,2v11.8c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z"
          />
        </defs>
        <use xlinkHref="#SVGID_5_" />
        <clipPath id="SVGID_6_">
          <use xlinkHref="#SVGID_5_" />
        </clipPath>
        <g className="st2" style={{ clipPath: "url(#SVGID_6_)" }}>
          <defs>
            <rect id="SVGID_7_" width="20" height="20" />
          </defs>
          <use xlinkHref="#SVGID_7_" />
          <clipPath id="SVGID_8_">
            <use xlinkHref="#SVGID_7_" />
          </clipPath>
          <rect
            x="-5"
            y="-5"
            className="st3"
            width="30"
            height="25.8"
            style={{ opacity: 0.2, clipPath: "url(#SVGID_8_)", fill: props.color }}
          />
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Booking/Seat.js